import  React, { useEffect, useRef, useState } from 'react';
import { StyleSheet, View, Text, Alert, TextInput as ReactText, ActivityIndicator, ImageBackground, TouchableOpacity, Platform, ScrollView, Dimensions} from 'react-native';
import { MyButton, DataGridView, TextInputTemp } from './buttonsAndControls';
import  { DefaultTheme, IconButton, TextInput, Modal, Provider as PaperProvider, Portal }  from 'react-native-paper';
import BarChart from './barChart';
import { useNavigation, NavigationProp } from '@react-navigation/native';
import { avatarImageString, branch, companyDir, company_Address, company_Name, company_Phone, getCompanyData, header, headerText, regModal, registerModal, stopCodes, stopExecutions } from './StockAwareTempData';
import AddStock from './AddStock';
import { DEBUG, enablePromise, openDatabase } from 'react-native-sqlite-storage';
import Registration from './registration';
import { deleteObject, getDownloadURL, getStorage, listAll, ref } from 'firebase/storage';
import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, getFirestore, limit, orderBy, query, serverTimestamp, updateDoc, where } from 'firebase/firestore';


const darkColour='#2a2d3e';
const isColorWhite='white';

interface Children {
  id: string;
  texts: string[];
};

interface OutOfStock {
  itemName: string;
  quantity: number;
};

interface Expenses {
  id: string;
  date: string;
  description: string;
  expenses_Type: string;
  amount: number;
};

const Dashboard = () => {
   const [lowOne, setLowOne] = useState(' ')
  const [lowTwo, setLowTwo] = useState(' ')
  const [lowThree, setLowThree] = useState(' ')
  const [lowOneQ, setLowOneQ] = useState(' ')
  const [lowTwoQ, setLowTwoQ] = useState(' ')
  const [lowThreeQ, setLowThreeQ] = useState(' ')
  const [highOne, setHighOne] = useState(' ')
  const [highTwo, setHighTwo] = useState(' ')
  const [highThree, setHighThree] = useState(' ')
  const [highOneQ, setHighOneQ] = useState(' ')
  const [highTwoQ, setHighTwoQ] = useState(' ')
  const [highThreeQ, setHighThreeQ] = useState(' ')
  const navigation = useNavigation()
  const [isDisabled, setIsDisabled] = useState(false)
  const [lowestQuantityData, setLowestQuantityData] = useState<{ quantity: any; item: any; }[]>([]);
  const [todaySales, setTodaySales] = useState(' ')
  const [toBeDelivered, setToBeDelivered] = useState(' ')
  const [thirtyMostB, setThirtyMostB] = useState(' ')
  const [thirtyMostQ, setThirtyMostQ] = useState(' ')
  const [mostSourcedB, setMostSourcedB] = useState(' ')
  const [mostSourcedQ, setMostSourcedQ] = useState(' ')
  const [mostSourcedBSeven, setMostSourcedBSeven] = useState(' ')
  const [mostSourcedQSeven, setMostSourcedQSeven] = useState(' ')
  const [leastBInSeven, setLeastBInSeven] = useState(' ')
  const [leastQInSeven, setLeastQInSeven] = useState(' ')
  const boardsArray: OutOfStock[] = [];
  const [zeroBoards, setZeroBoards] = useState<OutOfStock[]>([]);
  const [zeroModal, setZeroModal] = useState(false);
  const [expensesModal, setExpensesModal] = useState(false)
  const [addExpensesModal, setAddExpensesModal] = useState(false)
  const qtyRef = useRef<ReactText>(null);
  const [expensesArray, setExpensesArray] = useState<Expenses[]>([]);
  const [oneOnly, setOneOnly] = useState('')
  const [expAmount, setExpAmount] = useState('')
	const [descriptionText, setDescriptionText] = useState('')
  const updateIsMobile = () => {
    setIsMobile(window.innerWidth < 768); // Adjust the breakpoint as needed
  };
  const [isMobile, setIsMobile] = useState(false);
  const db = getFirestore();
  const [correctDateTime, setCorrectDateTime] = useState([])

  useEffect(() => {
    // Initial check
    updateIsMobile();

    // Listen for window resize events and update `isMobile`
    Dimensions.addEventListener('change', updateIsMobile);

    // Clean up the event listener when the component unmounts
    return () => {
      Dimensions.addEventListener('change', updateIsMobile);
    };
  }, []);

  const receiptTime = {
    someField: 'receiptTime',
    receiptTime: serverTimestamp(),
  };

  const correctDate = async () => {
    try {
      const docRef = await addDoc(collection(db, companyDir, branch, 'receipt'), receiptTime);
  
      const documentSnapshot = await getDoc(docRef);
      if (documentSnapshot.exists()) {
        const data = documentSnapshot.data().receiptTime.toDate();
        const date = new Date(data);
        data.setHours(0, 0, 0, 0)
        // const date = new Date(data);
  
        // const day = String(date.getDate()).padStart(2, '0');
        // const month = String(date.getMonth() + 1).padStart(2, '0');
        // const year = date.getFullYear();
        // const hours = String(date.getHours()).padStart(2, '0');
        // const minutes = String(date.getMinutes()).padStart(2, '0');
        // const seconds = String(date.getSeconds()).padStart(2, '0');
        // const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  
        // Delete the document
        await deleteDoc(documentSnapshot.ref);
  
        // Return the formatted date
        return data;
      } else {
        console.log('Document does not exist.');
        return null;
      }
    } catch (error) {
      console.error('Error:', error);
      throw error; // Rethrow the error for the caller to handle
    }
  };

  const fetchCompany = async() => {

    let _companyName = '';
    let _companyPhone = '';
    let _companyAddress = '';

    const companyCollectionRef = collection(db, companyDir, branch, 'company'); // Replace 'Company' with your Firestore collection name
    const companyQuery = query(companyCollectionRef, limit(1)); // Limit to the first document

    const querySnapshot = await getDocs(companyQuery);

    if (querySnapshot.size > 0) {
      querySnapshot.forEach(async(doc) => {
        const companyData = doc.data();
        if (companyData.phone1 && companyData.phone2) {
          _companyPhone = companyData.phone1 + ', ' + companyData.phone2;
        } else if (companyData.phone1) {
          _companyPhone = companyData.phone1;
        } else if (companyData.phone2) {
          _companyPhone = companyData.phone2;
        }
        _companyName = companyData.companyName;
        _companyAddress = companyData.address;
      })
      getCompanyData(_companyName, _companyAddress, _companyPhone);
     
    }
  }

  const fetchLowQAndHighQData = async () => {

    // Query for low quantity items
    const lowQuantityQuery = query(
      collection(db, companyDir, branch, 'stocks'),
      where('quantity', '>', 0),
      orderBy('quantity', 'asc'),
      limit(3)
    );

    // Query for high quantity items
    const highQuantityQuery = query(
      collection(db, companyDir, branch, 'stocks'),
      where('quantity', '>', 0),
      orderBy('quantity', 'desc'),
      limit(3)
    );

    const lowQuantitySnapshot = await getDocs(lowQuantityQuery);
    const highQuantitySnapshot = await getDocs(highQuantityQuery);

    const lowQuantityData = lowQuantitySnapshot.docs.map((doc) => {
      const data = doc.data();
      return { quantity: data.quantity, item: data.itemName };
    });

    const highQuantityData = highQuantitySnapshot.docs.map((doc) => {
      const data = doc.data();
      return { quantity: data.quantity, item: data.itemName };
    });

    setLowestQuantityData(lowQuantityData.concat(highQuantityData));
  };

  const fetchTodaySalesData = async () => {
    const salesItemsCollection = collection(db, companyDir, branch, 'salesItems');
    const now = new Date();
    now.setHours(now.getHours());
    // Query for sales items where the date is greater than or equal to one hour from now
    const querySnapshot = await getDocs(
      query(salesItemsCollection, where('date', '>=', correctDateTime[0]))
    );

    const rowCount = querySnapshot.size;
    setTodaySales(rowCount.toString());
  };

  const fetchToBeDeliveredData = async () => {
    const salesItemsCollection = collection(db, companyDir, branch, 'salesItems');

    // Query for sales items where 'Delivered' is 'No'
    const querySnapshot = await getDocs(query(salesItemsCollection, where('delivered', '==', 'No')));

    const rowCount = querySnapshot.size;
    setToBeDelivered(rowCount.toString());
  };

  const fetchThirtyMostBoardData = async () => {
    const salesItemsCollection = collection(db, companyDir, branch, 'salesItems');

    const endDate = new Date(correctDateTime[0]);
    endDate.setHours(23, 59, 59, 999);
    
    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 30)
    // Query for sales items within the last 30 days
    const querySnapshot = await getDocs(
      query(
        salesItemsCollection,
        where('date', '>=', startDate),
        where('date', '<=', endDate),
        orderBy('date'), // Add an orderBy clause for the 'date' field
      )
    );

    const boardsQuantityMap = {};

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const board = data.board;
      const quantity = data.quantity;
    
      if (!boardsQuantityMap[board]) {
        boardsQuantityMap[board] = 0;
      }
    
      boardsQuantityMap[board] += quantity;
    });
    const sortedBoards = Object.keys(boardsQuantityMap).sort(
      (a, b) => boardsQuantityMap[b] - boardsQuantityMap[a]
    );
    
    if (sortedBoards.length > 0) {
      const mostSoldBoard = sortedBoards[0];
      const totalQuantity = boardsQuantityMap[mostSoldBoard];
      setThirtyMostB(mostSoldBoard);
      setThirtyMostQ(totalQuantity);
    } else {
      console.log('No data found');
    }
  };

  const fetchMostSourcedBoard = async() => {
    const salesItemsRef = collection(db, companyDir, branch, 'salesItems');

    // Calculate the start and end timestamps for the query
    const endDate = new Date(correctDateTime[0]);
    endDate.setHours(23, 59, 59, 999);
    
    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 30)
    
    // Query the "Sales_Items" collection
    const querySnapshot = await getDocs(
      query(
        salesItemsRef,
        where('date', '>=', startDate),
        where('date', '<=', endDate),
        orderBy('date'), // Add an orderBy clause for the 'date' field
      )
    );

    const boardsQuantityMap = {};

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const board = data.board;
      const quantity = data.quantity;
    
      if (!boardsQuantityMap[board]) {
        boardsQuantityMap[board] = 0;
      }
    
      boardsQuantityMap[board] += 1;
    });
    const sortedBoards = Object.keys(boardsQuantityMap).sort(
      (a, b) => boardsQuantityMap[b] - boardsQuantityMap[a]
    );
    
    if (sortedBoards.length > 0) {
      const mostSoldBoard = sortedBoards[0];
      const totalQuantity = boardsQuantityMap[mostSoldBoard];
      setMostSourcedB(mostSoldBoard);
      setMostSourcedQ(totalQuantity);
    } else {
      console.log('No data found');
    }
  }

  const fetchSevenMostSourcedBoard = async() => {
    const salesItemsRef = collection(db, companyDir, branch, 'salesItems');

    // Calculate the start and end timestamps for the query
    const endDate = new Date(correctDateTime[0]);
    endDate.setHours(23, 59, 59, 999);
    
    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 7)
    
    // Query the "Sales_Items" collection
    const querySnapshot = await getDocs(
      query(
        salesItemsRef,
        where('date', '>=', startDate),
        where('date', '<=', endDate),
        orderBy('date'), // Add an orderBy clause for the 'date' field
      )
    );

    const boardsQuantityMap = {};

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const board = data.board;
    
      if (!boardsQuantityMap[board]) {
        boardsQuantityMap[board] = 0;
      }
    
      boardsQuantityMap[board] += 1;
    });
    const sortedBoards = Object.keys(boardsQuantityMap).sort(
      (a, b) => boardsQuantityMap[b] - boardsQuantityMap[a]
    );
    
    if (sortedBoards.length > 0) {
      const mostSoldBoard = sortedBoards[0];
      const totalQuantity = boardsQuantityMap[mostSoldBoard];
      setMostSourcedBSeven(mostSoldBoard);
      setMostSourcedQSeven(totalQuantity);
    } else {
      console.log('No data found');
    }
  }

  const fetchSevenLeastBoard = async() => {
    // Define the reference to the "Sales_Items" collection
    const salesItemsRef = collection(db, companyDir, branch, 'salesItems');

    // Calculate the start and end timestamps for the query
    const endDate = new Date(correctDateTime[0]);
    endDate.setHours(23, 59, 59, 999);
    
    const startDate = new Date(endDate);
    startDate.setDate(startDate.getDate() - 7)
    
    // Query the "Sales_Items" collection
    const querySnapshot = await getDocs(
      query(
        salesItemsRef,
        where('date', '>=', startDate),
        where('date', '<=', endDate),
        orderBy('date'), // Add an orderBy clause for the 'date' field
      )
    );

    const boardsQuantityMap = {};

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      const board = data.board;
      const quantity = data.quantity;
    
      if (!boardsQuantityMap[board]) {
        boardsQuantityMap[board] = 0;
      }
    
      boardsQuantityMap[board] += quantity;
    });
    const sortedBoards = Object.keys(boardsQuantityMap).sort(
      (a, b) => boardsQuantityMap[a] - boardsQuantityMap[b]
    );
    
    if (sortedBoards.length > 0) {
      const leastSoldBoard = sortedBoards[0];
      const totalQuantity = boardsQuantityMap[leastSoldBoard];
      setLeastBInSeven(leastSoldBoard);
      setLeastQInSeven(totalQuantity);
    } else {
      console.log('No data found');
    }
  }

  const fetchZeroBoards = async() => {
    // Define the reference to the "Stocks" collection
    const stocksRef = collection(db, companyDir, branch, 'stocks');

    // Create a query to get items with Quantity = 0
    const q = query(stocksRef, where('quantity', '==', 0));

    // Execute the query and retrieve the data
    getDocs(q)
      .then((querySnapshot) => {
        const boardsArray = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          boardsArray.push({ quantity: data.quantity, itemName: data.itemName });
        });
        setZeroBoards(boardsArray);
      })
      .catch((error) => {
        console.error('Error executing Firestore query', error);
      });
      setZeroModal((prev)=> !prev)
  }

  const fetchExpensesArray = async() => {
    // Define the reference to the "Expenses" collection
  const expensesRef = collection(db, companyDir, branch, 'expenses');

  // Create a query to get expenses where the Date is within the next hour
  const endDate = new Date(correctDateTime[0]);
  endDate.setHours(23, 59, 59, 999);

  const startDate = new Date(endDate);
  startDate.setHours(0, 0, 0, 0);

  const q = query(
    expensesRef,
    where('date', '>=', startDate),
    where('date', '<=', endDate),
    orderBy('date', 'desc') // Add an orderBy clause for the 'Date' field
  );

  // Execute the query and retrieve the data
  getDocs(q)
    .then((querySnapshot) => {
      const array = [];
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        array.push(data);
      });
      setExpensesArray(array);
    })
    .catch((error) => {
      console.error('Error executing Firestore query', error);
    });

    setExpensesModal((prev)=> !prev)
  }

  useEffect(() => {
    if (stopCodes === false) {
      const usecodes = async() => {
        await correctDate()
          .then((accurateDate) => {
            correctDateTime.unshift(accurateDate);
            fetchCompany();
            fetchLowQAndHighQData();
            fetchTodaySalesData();
            fetchToBeDeliveredData();
            fetchThirtyMostBoardData();
            fetchMostSourcedBoard();
            fetchSevenMostSourcedBoard();
            fetchSevenLeastBoard();
            fetchExpensesArray();
            fetchZeroBoards();
          })
      }
      usecodes();
    };
  }, [stopCodes]);

  const ChildProvider = ({texts, isExpenses, isChecked, pressed, index}: Children 
    & {index: number, isExpenses: boolean, isChecked: boolean, pressed: () => void}) => {
    const sizes: number[] = [330, 44];
    const ExpSizes: number[] = [254, 120];
    return(
      <TouchableOpacity style={{...stylesBox.childStyle, backgroundColor: isChecked ? darkColour : 'white'}} onPress={()=>pressed()}>
        {texts.map((text, i) => (
          <View key={i} style={{...stylesBox.childSubStyle, width: isExpenses ? ExpSizes[i] : sizes[i]}}>
            <Text key={i} style={{...stylesBox.childTextStyle, color: isExpenses ? isChecked ? 'white' : darkColour : '#BF2321'}}>
              {text}
            </Text>
          </View>
        ))}
      </TouchableOpacity>
    )
  }


// Initialize Firebase Storage
const storage = getStorage();

// Reference to your Firestore Cloud Storage bucket
const storageRef = ref(storage, "gs://willijofirebase.appspot.com");

// Function to monitor and process files
async function monitorAndProcessFiles() {
  try {
    // List all files in the storage bucket
    const result = await listAll(storageRef);

    for (const itemRef of result.items) {
      try {
        // Download the file to a local directory
        const downloadUsingHost = 'http://localhost:3000/download/' + itemRef.name; //used for download through server to bypass cors
        //const downloadURL = await getDownloadURL(itemRef);
        // const encodedDownloadURL = encodeURIComponent(downloadURL);
        // const runServerScript = `http://localhost:3000/run-powershell-script?downloadURL="${encodedDownloadURL}"`;

        // fetch(runServerScript)
        //   .then((response) => response.blob())
        //   .then((blob) => {
        //     // Create a URL for the blob   
        //     const blobUrl = URL.createObjectURL(blob);
        //     // Create a link element to trigger the download  
        //     const link = document.createElement('a');
        //     link.href = blobUrl;
        //     //link.download = itemRef.name; // Specify the desired file name
        //     link.click();
            
        //     return blobUrl

        //   })
        //   .then(async (blobUrl) => {
        //     await URL.revokeObjectURL(blobUrl);
        //     await deleteObject(itemRef);              
        //   })
        //   .catch((error) => {
        //     console.error('Error downloading file:', error);
        //   })

        fetch(downloadUsingHost)
        .then((response) => response.text()) // Assuming the server sends back a text response
        .then(async (responseText) => {
          await deleteObject(itemRef);
        })
        .catch((error) => {
          console.error('Error:', error);
        });

        console.log('File deleted from Firestore Cloud Storage');
      } catch (error) {
        console.error('Error processing file:', error);
      }
    }
    // Sleep for a specified duration before checking again (e.g., every 5 minutes)
    await new Promise((resolve) => setTimeout(resolve, 30000)); // 5 minutes
  } catch (error) {
    console.error('Error listing files:', error);
  }
}

// Start the monitoring loop


  useEffect(() => {
    monitorAndProcessFiles()
      .catch((error) => {
        console.error('Monitoring loop error:', error);
      });
    if (stopCodes === false) {
      if (lowestQuantityData.length > 5) {
        setLowOne(lowestQuantityData[0].item.toString());
        setLowOneQ(lowestQuantityData[0].quantity.toString() + ' boards');
        setLowTwo(lowestQuantityData[1].item.toString());
        setLowTwoQ(lowestQuantityData[1].quantity.toString() + ' boards');
        setLowThree(lowestQuantityData[2].item.toString());
        setLowThreeQ(lowestQuantityData[2].quantity.toString() + ' boards');

        setHighOne(lowestQuantityData[3].item.toString());
        setHighOneQ(lowestQuantityData[3].quantity.toString() + ' boards');
        setHighTwo(lowestQuantityData[4].item.toString());
        setHighTwoQ(lowestQuantityData[4].quantity.toString() + ' boards');
        setHighThree(lowestQuantityData[5].item.toString());
        setHighThreeQ(lowestQuantityData[5].quantity.toString() + ' boards');
      }
    }
  }, [lowestQuantityData, stopCodes]);
  
  

  const handleAddToExpenses = async () => {
    if (expAmount.charAt(0) === '0') {
      window.alert ('Invalid!\nZero entered. You can exit the dialog if there is no expenses to enter.')
    } else if (expAmount.trim() === ''|| isNaN(parseInt(expAmount, 10))) {
      window.alert ('Null!\nYou have not entered an amount')
    } else if (descriptionText.trim() === '') {
      window.alert ('Null!\nYou must enter an expenses description')
    } else {
      const expensesCollection = collection(db, companyDir, branch, 'expenses');

      const data = {
        date: serverTimestamp(),
        description: descriptionText,
        expensesType: 'Cash',
        amount: expAmount,
      };

      const expDoc = await addDoc(expensesCollection, data);
      updateDoc(expDoc, {id: expDoc.id})

      const endDate = new Date(correctDateTime[0]);
      endDate.setHours(23, 59, 59, 999);

      const startDate = new Date(endDate);
      startDate.setHours(0, 0, 0, 0);

      const expensesQuery = query(expensesCollection, where('date', '>=', startDate), where('date', '<=', endDate));

      // Fetch the documents
      getDocs(expensesQuery)
        .then((querySnapshot) => {
          const array = [];
          querySnapshot.forEach((doc) => {
            const data = doc.data();
            array.unshift(data);
          });
          setExpensesArray(array);
        })
        .catch((error) => {
          console.error('Error fetching documents: ', error);
        });

      setAddExpensesModal(false);
    }
  };

  const deleteSelected = (id: string) => {
    const updatedChildViews = expensesArray.filter((item) => item.id !== id);
    setExpensesArray(updatedChildViews);
     deleteFromDB(id);
		 setOneOnly('')
  };

  const deleteFromDB = async (id: string) => {
    const expensesRef = doc(db, companyDir, branch, 'expenses', '');

    // Delete the document
    deleteDoc(expensesRef)
      .then(() => {
        console.log('Deleted Successfully');
      })
      .catch((error) => {
        console.error('Error deleting document:', error);
      });

	};


  const handleExpensesPressed = ( ID: string) => {
		if (oneOnly === ID?.toString()) {
			setOneOnly('')
		} else {
			setOneOnly(ID?.toString())
		}

	};

  const handleExpenses = async() => {
    const expensesCollection = collection(db, companyDir, branch, 'expenses');
    const endDate = new Date(correctDateTime[0]);
    endDate.setHours(23, 59, 59, 999);

    const startDate = new Date(endDate);
    startDate.setHours(0, 0, 0, 0);

    const expensesQuery = query(expensesCollection, where('date', '>=', startDate), where('date', '<=', endDate));

    // Fetch the documents
    getDocs(expensesQuery)
      .then((querySnapshot) => {
        const array = [];
        querySnapshot.forEach((doc) => {
          const data = doc.data();
          array.unshift(data);
        });
        setExpensesArray(array);
      })
      .catch((error) => {
        console.error('Error fetching documents: ', error);
      });

      setExpensesModal((prev) => !prev)
  }
  
  const handleNewSales = () => {
    stopExecutions(true)
    setTimeout(() => {
      navigation.navigate('NewSales' as never)
    }, 100);
  }

  const handleViewSales = () => {
    stopExecutions(true)
    setTimeout(() => {
      navigation.navigate('SalesRecord' as never)
		}, 100);
  }

  const handleAddStock = () => {
    setTimeout(() => {
      setIsDisabled((prev) => !prev)
		}, 100);
  }

  const handleViewStock = () => {
    stopExecutions(true)
    setTimeout(() => {
      navigation.navigate('ViewStock' as never)
		}, 100);
  }

  const handlePurchaseHistory = () => {
    stopExecutions(true)
    setTimeout(() => { 
      navigation.navigate('PurchaseRecord' as never)
		}, 100);
  }

  const handleSavedForLater = () => {
    stopExecutions(true)
    setTimeout(() => { 
      navigation.navigate('SavedForLater' as never)
		}, 100);
  };

  const handleSalesPerCustomer = () => {
    stopExecutions(true)
    setTimeout(() => { 
      navigation.navigate('SalesPerCustomer' as never)
		}, 100);
  };

  const handleTotalAndExpenses = () => {
    stopExecutions(true)
    setTimeout(() => { 
      navigation.navigate('TotalAndExpenses' as never)
		}, 100);
  }

  const handleReport= () => {
    stopExecutions(true)
    setTimeout(() => { 
      navigation.navigate('Report' as never)
		}, 100);
  };

  const theme = {
    ...DefaultTheme,
    colors: {
      ...DefaultTheme.colors,
      backdrop: 'rgba(0, 0, 0, 0.6)', // Customize the overlay color here
    },
  };

  const [showReg, setShowReg] = useState(false)
  
  
  return(
    <PaperProvider theme={theme}>
      {!isMobile ? 
      <ScrollView style={{ width: 1600 , backgroundColor: 'pink'}} persistentScrollbar = {true}>
      <View style={{flexDirection:'row'}}>
        <View style={{        //Sales activity box
          borderWidth:2,  
          borderColor:'#DCE3E8', 
          borderRadius:10, 
          padding:15, 
          margin:10, 
          width:250,
          height:355, 
          backgroundColor:isColorWhite
          }}>
           
          <Text style={{...stylesBox.mediumText, margin:10, textAlign:'left', color:darkColour, fontSize:20}}>
            Sales Activity
          </Text>
          <View style={stylesBox.smallBox}>
            <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
              <Text style={{...stylesBox.mediumText, fontSize:18, marginBottom:5}}>
                Today's sales
              </Text>
              <Text style={stylesBox.bigText}>
               {todaySales}
              </Text>
              <Text style={stylesBox.smallText}>
                Sales
              </Text>

              <View style={{flexDirection:'row', alignSelf:'flex-start', marginTop:-8}}>
                <IconButton icon="check-all" iconColor='#2A6AA7' size={18} containerColor={isColorWhite} focusable={false}/>
                  <Text style={{...stylesBox.mediumText, paddingTop:9, marginLeft:-5}}>
                    Completed
                  </Text>
              </View>
            </TouchableOpacity>
          </View>

          <View style={stylesBox.smallBox}>
            <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
              <Text style={{...stylesBox.mediumText, fontSize:18, marginBottom:5}}>
                To be Delivered
              </Text>
              <Text style={{...stylesBox.bigText, color:'#EECE17'}}>
                {toBeDelivered}
              </Text>
              <Text style={stylesBox.smallText}>
                Sales
              </Text>

              <View style={{flexDirection:'row', alignSelf:'flex-start', marginTop:-8}}>
                <IconButton icon="check" iconColor='#2A6AA7' size={18} containerColor={isColorWhite} focusable={false}/>
                <Text style={{...stylesBox.mediumText, paddingTop:9, marginLeft:-5}}>
                  Sold not delivered
                </Text>
              </View>
            </TouchableOpacity>
          </View>
        </View>
        <View>
          <View style={{
            borderWidth:2,  //Leaderboard
            borderColor:'#DCE3E8', 
            borderRadius:10, 
            padding:15, 
            margin:10, 
            marginLeft: 0,
            width:880,
            height:234, 
            backgroundColor: isColorWhite
            }}>
      
            <Text style={{...stylesBox.mediumText, margin:10, textAlign:'left', color:darkColour, fontSize:20}}>
              Sales Leaderboard
            </Text>
            <View style={{flexDirection:'row'}}>
              <View>
                <View style={stylesBox.smallBox}>
                  <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
                    <Text style={{...stylesBox.mediumText, fontSize:15, marginBottom:0, height:37}}>
                      {mostSourcedB}
                    </Text>
                    <Text style={{...stylesBox.bigText, color:'#5A8E60'}}>
                      {mostSourcedQ}
                    </Text>
                    <Text style={{...stylesBox.smallText, marginTop:-2}}>
                      Sales
                    </Text>

                    <View style={{flexDirection:'row', alignSelf:'center', marginTop:-8}}>
                      <Text style={{...stylesBox.mediumText, paddingTop:5}}>
                        Last 30 days
                      </Text>
                    </View>
                  </TouchableOpacity>
                </View>
                <View style= {{...stylesBox.smallBox, marginTop:-5, width: 190, height:30, borderRadius:8}}>
                  <Text style={{...stylesBox.mediumText, marginTop:3}}>
                    Monthly Most Wanted
                  </Text>
                </View>
              </View>
              <View>
                <View style={stylesBox.smallBox}>
                  <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
                    <Text style={{...stylesBox.mediumText, fontSize:15, marginBottom:0, height:37}}>
                      {mostSourcedBSeven}
                    </Text>
                    <Text style={{...stylesBox.bigText, color:'#8E5A5A'}}>
                      {mostSourcedQSeven}
                    </Text>
                    <Text style={{...stylesBox.smallText, marginTop:-2}}>
                      Sales
                    </Text>

                    <View style={{flexDirection:'row', alignSelf:'center', marginTop:-8}}>
                      <Text style={{...stylesBox.mediumText, paddingTop:5}}>
                        Last 7 days
                      </Text>
                    </View>
                  </TouchableOpacity>
                </View>
                <View style= {{...stylesBox.smallBox, marginTop:-5, width: 190, height:30, borderRadius:8}}>
                  <Text style={{...stylesBox.mediumText, marginTop:3}}>
                    Weekly Most Wanted
                  </Text>
                </View>
              </View>

              <View>
                <View style={stylesBox.smallBox}>
                  <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
                    <Text style={{...stylesBox.mediumText, fontSize:15, marginBottom:0, height:37}}>
                      {thirtyMostB}
                    </Text>
                    <Text style={{...stylesBox.bigText, color:'#5D6D7E'}}>
                      {thirtyMostQ}
                    </Text>
                    <Text style={{...stylesBox.smallText, marginTop:-2}}>
                      Qty
                    </Text>
                    <View style={{flexDirection:'row', alignSelf:'center', marginTop:-8}}>
                      <Text style={{...stylesBox.mediumText, paddingTop:5}}>
                        Last 30 days
                      </Text>
                    </View>
                  </TouchableOpacity>
                </View>
                <View style= {{...stylesBox.smallBox, marginTop:-5, width: 190, height:30, borderRadius:8}}>
                  <Text style={{...stylesBox.mediumText, marginTop:3}}>
                    Monthly Highest Quantity
                  </Text>
                </View>
              </View>

              <View>
                <View style={stylesBox.smallBox}>
                  <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
                    <Text style={{...stylesBox.mediumText, fontSize:15, marginBottom:0, height:37}}>
                      {leastBInSeven}
                    </Text>
                    <Text style={{...stylesBox.bigText, color:'#D35400'}}>
                      {leastQInSeven}
                    </Text>
                    <Text style={{...stylesBox.smallText, marginTop:-2}}>
                      Qty
                    </Text>

                    <View style={{flexDirection:'row', alignSelf:'center', marginTop:-8}}>
                      <Text style={{...stylesBox.mediumText, paddingTop:5}}>
                        Last 7 days
                      </Text>
                    </View>
                  </TouchableOpacity>
                </View> 
                <View style= {{...stylesBox.smallBox, marginTop:-5, width: 190, height:30, borderRadius:8}}>
                  <Text style={{...stylesBox.mediumText, marginTop:3}}>
                    Weekly Lowest Quantity
                  </Text>
                </View>
              </View>
            </View>
          </View>
          
      <View style={{margin:10}}> 
        <MyButton 
        btnText='New sales' 
        btnBorClr={darkColour} 
        btnBorWdt={2} 
        btnColor='white' 
        btnHeight={40} 
        btnTxtClr={darkColour}
        btnFontSize={17}
        btnWidth={200}
        btnBorRadius={10}
        btnPadding={8}
        hndClicked={handleNewSales}
        />
      </View>

      <View style={{margin:10}}>
        <MyButton btnText='View sales' 
        btnBorClr={darkColour} 
        btnBorWdt={0} 
        btnColor= {darkColour}
        btnHeight={40} 
        btnTxtClr={isColorWhite}
        btnFontSize={17}
        btnWidth={200}
        btnBorRadius={10}
        btnPadding={8}
        hndClicked={handleViewSales}
        />
      </View>
    </View>
    <View style={{margin:10, marginLeft: 0}}>
     {stopCodes === false && <BarChart/>} 
    </View>
  </View>
  <View style={{flexDirection:'row' //The stock alert row
  }}>
    <View style={{...stylesBox.smallBox, width:500, height:320}}>
      <Text style={{...stylesBox.mediumText, fontSize:20, alignSelf:'flex-start', color:'black', marginLeft:20, marginTop:20}}>
        Stock Alert
      </Text>
      
      <View>
        <View style={{flexDirection:'column'}}>
          <Text style={{...stylesBox.mediumText, textAlign:'left', marginTop:20, marginBottom:10, marginLeft:20, fontSize:18, fontWeight:'500', color:'black'}}>
            Lowest 3 stock
          </Text>
          <View style={{flexDirection:'row'}}>
            <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color: darkColour}}>
             {lowOne}
            </Text>
            <View style={{flex:1}}>
              <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
                <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#CC2608'}}>
                   {lowOneQ}
                </Text>
                
              </View>
            </View>
          </View>

          <View style={{flexDirection:'row'}}>
            <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color:darkColour}}>
            {lowTwo}
            </Text>
            <View style={{flex:1}}>
              <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
                <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#CC2608'}}>
                {lowTwoQ}
                </Text>
                
              </View>
            </View>
          </View>
          <View style={{flexDirection:'row'}}>
            <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color:darkColour}}>
            {lowThree}
            </Text>
            <View style={{flex:1}}>
              <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
                <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#CC2608'}}>
                {lowThreeQ}
                </Text>
                
              </View>
            </View>
          </View>
        </View>

        <View style={{flexDirection:'column'}}>
          <Text style={{...stylesBox.mediumText, marginTop: 20, marginBottom:10, textAlign:'left', marginLeft:20, fontSize:18, fontWeight:'500', color:'black'}}>
            Highest 3 stock
          </Text>
          <View style={{flexDirection:'row'}}>
            <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color:darkColour}}>
            {highOne}
            </Text>
            <View style={{flex:1}}>
              <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
                <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#099B2F'}}>
                    {highOneQ}
                </Text>
                
              </View>
            </View>
          </View>

          <View style={{flexDirection:'row'}}>
            <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color: darkColour}}>
           {highTwo}
            </Text>
            <View style={{flex:1}}>
              <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
                <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#099B2F'}}>
                    {highTwoQ}
                </Text>
                
              </View>
            </View>
          </View>
          <View style={{flexDirection:'row'}}>
            <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color:darkColour}}>
            {highThree}
            </Text>
            <View style={{flex:1}}>
              <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
                <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#099B2F'}}>
                    {highThreeQ}
                </Text>
                
              </View>
            </View>
          </View>
        </View>

      </View>
    </View>
    <View>
      <View style={{...stylesBox.smallBox, height:442, width:630, marginLeft: 0, marginTop:-112}}>
         {stopCodes === false &&  <DataGridView/>}
      </View>
    </View>
    <View style={{...stylesBox.smallBox, width:410, height:320, marginLeft: 0}}>
      <View style={{height:160, borderWidth:0, borderBottomWidth:1, alignItems:'center'}}>
         <TouchableOpacity style={{width:370, height: 40, marginTop:10, backgroundColor: darkColour, borderRadius:10, flexDirection:'row',
          borderBottomLeftRadius: zeroModal? 0 : 10, borderBottomRightRadius: zeroModal? 0 : 10 }} onPress={fetchZeroBoards}>
            <Text style={{...stylesBox.mediumText, color:'white', flex:7, marginRight:0, paddingTop:5, fontSize:17}}>
              Out of stock boards
            </Text>
            <View style={{flex:1, alignItems:'flex-end'}}>
              <IconButton icon= {zeroModal? "chevron-down" : "chevron-up"} 
              iconColor={'white'} size={25} style={{width:34, height:34, margin:3, padding:2}} containerColor={'transparent'} focusable={false} />
            </View>
          </TouchableOpacity>
      </View>
    
      <View style={{height:160, borderWidth:0, alignItems:'center'}}>
        <TouchableOpacity style={{width:370, height: 40, marginTop:10, backgroundColor: darkColour, borderRadius:10, flexDirection:'row', 
          borderBottomLeftRadius: expensesModal? 0 : 10, borderBottomRightRadius: expensesModal? 0 : 10 }} onPress={handleExpenses}>
          <View style={{flex:2, alignItems:'flex-end'}}>
              <IconButton icon="plus-box-outline" iconColor={'white'} size={25} style={{width:34, height:34, margin:3, padding:2}} 
              containerColor={'transparent'} focusable={true} onPress={()=> setAddExpensesModal(true)}/>
            </View>
            <Text style={{...stylesBox.mediumText, color:'white', flex:7, marginRight:0, paddingTop:5, fontSize:17}}>
              Expenses tab
            </Text>
            {oneOnly?.trim() !== '' &&
            <View style={{flex:2, alignItems:'flex-start'}}>
              <IconButton icon="trash-can" iconColor={'white'} size={25} style={{width:34, height:34, margin:3, padding:2}} 
              containerColor={'transparent'} focusable={true} onPress={()=>deleteSelected(oneOnly)} />
            </View>
            }
            <View style={{flex:1, alignItems:'flex-end'}}>
              <IconButton icon= {expensesModal? "chevron-down" : "chevron-up"}
              iconColor={'white'} size={25} style={{width:34, height:34, margin:3, padding:2}} containerColor={'transparent'} focusable={false} />
            </View>
        </TouchableOpacity>
      </View>

    </View>
  </View>
  <View style={{flexDirection:'row', width:1560, marginLeft:10, marginBottom: 10}}>
    <View style={{marginTop:10}}>
      <AddStock onClicked={handleAddStock} showModal={isDisabled}/>
    </View>

    <View style={{flex:1, alignItems:'flex-end'}}>
      <View style={{ marginTop:10}}>
        <MyButton 
        btnText='View stock' 
        btnBorClr={isColorWhite}
        btnBorWdt={0} 
        btnColor={darkColour} 
        btnHeight={40} 
        btnTxtClr={isColorWhite}
        btnFontSize={17}
        btnWidth={200}
        btnBorRadius={10}
        btnPadding={9}
        hndClicked={handleViewStock}
        />
      </View>
    </View>

    <View style={{flex:1, alignItems:'flex-end'}}>
      <View style={{ marginTop:10}}>
        <MyButton 
        btnText='Purchase history' 
        btnBorClr={isColorWhite}
        btnBorWdt={0} 
        btnColor={darkColour} 
        btnHeight={40} 
        btnTxtClr={isColorWhite}
        btnFontSize={17}
        btnWidth={200}
        btnBorRadius={10}
        btnPadding={9}
        hndClicked={handlePurchaseHistory}
        />
      </View>
    </View>

    <View style={{flex:1, alignItems:'flex-end'}}>
      <View style={{ marginTop:10}}>
        <MyButton 
        btnText='Saved For Later' 
        btnBorClr={isColorWhite}
        btnBorWdt={0} 
        btnColor={darkColour} 
        btnHeight={40} 
        btnTxtClr={isColorWhite}
        btnFontSize={17}
        btnWidth={200}
        btnBorRadius={10}
        btnPadding={9}
        hndClicked={handleSavedForLater}
        />
      </View>
    </View>
    <View style={{flex:1, alignItems:'flex-end'}}>
      <View style={{ marginTop:10}}>
        <MyButton 
        btnText='Sales per customer' 
        btnBorClr={isColorWhite}
        btnBorWdt={0} 
        btnColor={darkColour} 
        btnHeight={40} 
        btnTxtClr={isColorWhite}
        btnFontSize={17}
        btnWidth={200}
        btnBorRadius={10}
        btnPadding={9}
        hndClicked={handleSalesPerCustomer}
        />
      </View>
    </View>

    <View style={{flex:1, alignItems:'flex-end'}}>
      <View style={{ marginTop:10}}>
        <MyButton 
        btnText='Total and expenses' 
        btnBorClr={isColorWhite}
        btnBorWdt={0} 
        btnColor={darkColour} 
        btnHeight={40} 
        btnTxtClr={isColorWhite}
        btnFontSize={17}
        btnWidth={200}
        btnBorRadius={10}
        btnPadding={9}
        hndClicked={handleTotalAndExpenses}
        />
      </View>
    </View>

    <View style={{flex:1, alignItems:'flex-end'}}>
      <View style={{ marginTop:10}}>
        <MyButton 
        btnText='Report' 
        btnBorClr={isColorWhite}
        btnBorWdt={0} 
        btnColor={darkColour} 
        btnHeight={40} 
        btnTxtClr={isColorWhite}
        btnFontSize={17}
        btnWidth={200}
        btnBorRadius={10}
        btnPadding={9}
        hndClicked={handleReport}
        />
      </View>
    </View>
  </View>
 
  <PaperProvider>
  <Portal>
    <Modal visible = {zeroModal} contentContainerStyle={{width:370, maxHeight: 100, borderWidth: 0, borderColor: 'transparent', marginTop: zeroBoards.length + 10 < 1 ? -621 : zeroBoards.length > 2 ? -576 : zeroBoards.length > 1 ? -608 : -641, marginLeft:1180, position:'relative' }} onDismiss={()=>setZeroModal(false)}>
      <ScrollView style={{borderColor:'black', borderWidth:2, borderTopWidth:0, borderBottomRightRadius:10, borderBottomLeftRadius:10}}>
        {zeroBoards.length > 0 ? zeroBoards.map((item, index) => (
          <ChildProvider
            key={item.itemName}
            texts={[item.itemName, item.quantity.toString()]}
            index={index}
            isExpenses = {false}
            isChecked = {false}
            pressed={()=>{}}
            id={item.itemName}
          />
        )) 
        : 
        <View style={{...stylesBox.childStyle, justifyContent:'center'}}>
          <Text style= {stylesBox.noZeroStock}>
            There is no out of stock boards
          </Text>
        </View>
        }
      </ScrollView>
    </Modal>
  </Portal>
  </PaperProvider>

  <PaperProvider>
  <Portal>
    <Modal visible = {expensesModal} contentContainerStyle={{width:370, maxHeight: 100, marginTop: expensesArray.length + 10 < 1 ? -301 : expensesArray.length > 2 ? -256 : expensesArray.length > 1 ? -288 : -321, marginLeft:1180, position:'relative' }} onDismiss={()=>setExpensesModal(false)}>
      <ScrollView style={{borderColor:'black', borderWidth:2, borderTopWidth:0, borderBottomRightRadius:10, borderBottomLeftRadius:10}}>
        {expensesArray.length > 0 ? expensesArray.map((item, index) => (
          <ChildProvider
            key={item.id}
            texts={[item.description, Number(item.amount).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })]}
            index={index}
            isExpenses = {true}
            isChecked={oneOnly === item.id?.toString() ? true : false}
            pressed={() =>{handleExpensesPressed(item.id)}}
            id={item.id?.toString()}
          />
        )) 
        : 
        <View style={{...stylesBox.childStyle, justifyContent:'center'}}>
          <Text style= {stylesBox.noZeroStock}>
            No expenses yet made today
          </Text>
        </View>
        }
      </ScrollView>
    </Modal>
  </Portal>
  </PaperProvider>

  <PaperProvider>
  <Portal>
    <Modal visible = {addExpensesModal} contentContainerStyle={{width:370, height: 145, backgroundColor:'white', borderWidth:2, borderColor:darkColour, borderRadius:10, marginTop: -292, marginLeft:1180}} onDismiss={()=>setZeroModal(false)}>
      <View style={{paddingVertical:5}}>
        <View style={{width:370, paddingHorizontal:3, flexDirection:'row'}}>
          <TextInputTemp refObject={qtyRef} lTxt="Amount(₦)" plhrTxt="Enter amount" cnWidth={220} 
            txtWidth={118} lbWidth={100} makeDigits ={true} onChangeText={(amt)=>setExpAmount(amt)} 
            enterKeyIsSunmit = {true} onSubmit={handleAddToExpenses}
          />
          <View style={{flex: 1, height:40, justifyContent:'flex-end', alignItems:'center' , marginTop:10, paddingHorizontal:4, flexDirection:'row'}}>
            <View>
               <MyButton btnText='Add' btnWidth={60} hndClicked={handleAddToExpenses} />
            </View>
           
            <IconButton icon="close-box" iconColor={darkColour} size={30} style={{width:45, height:45, margin:0, padding:2}} 
              containerColor={'transparent'} focusable={true} onPress={()=> setAddExpensesModal(false)}
            />
          </View>
        </View>

        <View style={{alignSelf:'center'}}>
          <ReactText
            placeholder= 'Expenses description'
            multiline
            numberOfLines={4}
            spellCheck ={false}
            style={stylesBox.notesText}
            onChangeText={(text)=> setDescriptionText(text)}
          />
        </View>

      </View>
    </Modal>
  </Portal>
  </PaperProvider>

</ScrollView>

  :
  
  <ScrollView style={{ flex:1 }} persistentScrollbar = {true}>
  <View style={{flexDirection:'column', alignSelf: 'center'}}>
    <View style={{        //Sales activity box
      borderWidth:2,  
      borderColor:'#DCE3E8', 
      borderRadius:10, 
      marginVertical:10, 
      width:250,
      height:355, 
      alignSelf: 'center',
      backgroundColor:isColorWhite
      }}>
       
      <Text style={{...stylesBox.mediumText, margin:10, marginLeft: 15, textAlign:'left', color:darkColour, fontSize:20}}>
        Sales Activity
      </Text>
      <View style={{...stylesBox.smallBox, alignSelf: 'center', margin: 0}}>
        <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
          <Text style={{...stylesBox.mediumText, fontSize:18, marginBottom:5}}>
            Today's sales
          </Text>
          <Text style={stylesBox.bigText}>
           {todaySales}
          </Text>
          <Text style={stylesBox.smallText}>
            Sales
          </Text>

          <View style={{flexDirection:'row', alignSelf:'flex-start', marginTop:-8}}>
            <IconButton icon="check-all" iconColor='#2A6AA7' size={18} containerColor={isColorWhite} focusable={false}/>
              <Text style={{...stylesBox.mediumText, paddingTop:9, marginLeft:-5}}>
                Completed
              </Text>
          </View>
        </TouchableOpacity>
      </View>

      <View style={{...stylesBox.smallBox, alignSelf: 'center', margin: 0}}>
        <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
          <Text style={{...stylesBox.mediumText, fontSize:18, marginBottom:5}}>
            To be Delivered
          </Text>
          <Text style={{...stylesBox.bigText, color:'#EECE17'}}>
            {toBeDelivered}
          </Text>
          <Text style={stylesBox.smallText}>
            Sales
          </Text>

          <View style={{flexDirection:'row', alignSelf:'flex-start', marginTop:-8}}>
            <IconButton icon="check" iconColor='#2A6AA7' size={18} containerColor={isColorWhite} focusable={false}/>
            <Text style={{...stylesBox.mediumText, paddingTop:9, marginLeft:-5}}>
              Sold not delivered
            </Text>
          </View>
        </TouchableOpacity>
      </View>
    </View>
    <View>
      <View style={{
        borderWidth:2,  //Leaderboard
        borderColor:'#DCE3E8', 
        borderRadius:10, 
        marginVertical:10, 
        marginLeft: 0,
        width:234,
        height:770, 
        alignSelf: 'center',
        backgroundColor: isColorWhite
        }}>
  
        <Text style={{...stylesBox.mediumText, margin: 10, marginLeft: 15, textAlign:'left', color:darkColour, fontSize:20}}>
          Sales Leaderboard
        </Text>
        <View style={{flexDirection:'column'}}>
          <View>
            <View style={{...stylesBox.smallBox, alignSelf: 'center', margin: 0}}>
              <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
                <Text style={{...stylesBox.mediumText, fontSize:15, marginBottom:0, height:37}}>
                  {mostSourcedB}
                </Text>
                <Text style={{...stylesBox.bigText, color:'#5A8E60'}}>
                  {mostSourcedQ}
                </Text>
                <Text style={{...stylesBox.smallText, marginTop:-2}}>
                  Sales
                </Text>

                <View style={{flexDirection:'row', alignSelf:'center', marginTop:-8}}>
                  <Text style={{...stylesBox.mediumText, paddingTop:5}}>
                    Last 30 days
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
            <View style= {{...stylesBox.smallBox, marginTop:-5, margin: 0, alignSelf: 'center', width: 190, height:30, borderRadius:8}}>
              <Text style={{...stylesBox.mediumText, marginTop:3}}>
                Monthly Most Wanted
              </Text>
            </View>
          </View>
          <View>
            <View style={{...stylesBox.smallBox, alignSelf: 'center', margin: 0}}>
              <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
                <Text style={{...stylesBox.mediumText, fontSize:15, marginBottom:0, height:37}}>
                  {mostSourcedBSeven}
                </Text>
                <Text style={{...stylesBox.bigText, color:'#8E5A5A'}}>
                  {mostSourcedQSeven}
                </Text>
                <Text style={{...stylesBox.smallText, marginTop:-2}}>
                  Sales
                </Text>

                <View style={{flexDirection:'row', alignSelf:'center', marginTop:-8}}>
                  <Text style={{...stylesBox.mediumText, paddingTop:5}}>
                    Last 7 days
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
            <View style= {{...stylesBox.smallBox, marginTop:-5, margin: 0, alignSelf: 'center', width: 190, height:30, borderRadius:8}}>
              <Text style={{...stylesBox.mediumText, marginTop:3}}>
                Weekly Most Wanted
              </Text>
            </View>
          </View>

          <View>
            <View style={{...stylesBox.smallBox, alignSelf: 'center', margin: 0}}>
              <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
                <Text style={{...stylesBox.mediumText, fontSize:15, marginBottom:0, height:37}}>
                  {thirtyMostB}
                </Text>
                <Text style={{...stylesBox.bigText, color:'#5D6D7E'}}>
                  {thirtyMostQ}
                </Text>
                <Text style={{...stylesBox.smallText, marginTop:-2}}>
                  Qty
                </Text>
                <View style={{flexDirection:'row', alignSelf:'center', marginTop:-8}}>
                  <Text style={{...stylesBox.mediumText, paddingTop:5}}>
                    Last 30 days
                  </Text>
                </View>
              </TouchableOpacity>
            </View>
            <View style= {{...stylesBox.smallBox, marginTop:-5, margin: 0, alignSelf: 'center', width: 190, height:30, borderRadius:8}}>
              <Text style={{...stylesBox.mediumText, marginTop:3}}>
                Monthly Highest Quantity
              </Text>
            </View>
          </View>

          <View>
            <View style={{...stylesBox.smallBox, margin: 0, alignSelf: 'center'}}>
              <TouchableOpacity style={{flex:1, alignItems:'center', flexDirection:'column'}}>
                <Text style={{...stylesBox.mediumText, fontSize:15, marginBottom:0, height:37}}>
                  {leastBInSeven}
                </Text>
                <Text style={{...stylesBox.bigText, color:'#D35400'}}>
                  {leastQInSeven}
                </Text>
                <Text style={{...stylesBox.smallText, marginTop:-2}}>
                  Qty
                </Text>

                <View style={{flexDirection:'row', alignSelf:'center', marginTop:-8}}>
                  <Text style={{...stylesBox.mediumText, paddingTop:5}}>
                    Last 7 days
                  </Text>
                </View>
              </TouchableOpacity>
            </View> 
            <View style= {{...stylesBox.smallBox, marginTop:-5, margin: 0, alignSelf: 'center', width: 190, height:30, borderRadius:8}}>
              <Text style={{...stylesBox.mediumText, marginTop:3}}>
                Weekly Lowest Quantity
              </Text>
            </View>
          </View>
        </View>
      </View>
      
  <View style={{margin:10, alignSelf: 'center'}}> 
    <MyButton 
    btnText='New sales' 
    btnBorClr={darkColour} 
    btnBorWdt={2} 
    btnColor='white' 
    btnHeight={40} 
    btnTxtClr={darkColour}
    btnFontSize={17}
    btnWidth={200}
    btnBorRadius={10}
    btnPadding={8}
    hndClicked={handleNewSales}
    />
  </View>

  <View style={{margin:10, alignSelf: 'center'}}> 
    <MyButton btnText='View sales' 
    btnBorClr={darkColour} 
    btnBorWdt={0} 
    btnColor= {darkColour}
    btnHeight={40} 
    btnTxtClr={isColorWhite}
    btnFontSize={17}
    btnWidth={200}
    btnBorRadius={10}
    btnPadding={8}
    hndClicked={handleViewSales}
    />
  </View>
</View>
<ScrollView style = {{
  width: 300, 
  alignSelf: 'center', 
  paddingTop: -2,
  paddingLeft: -2,
  borderRadius: 10,   
  borderWidth: 2, 
  borderColor:'#DCE3E8',
  marginVertical: 10}} showsHorizontalScrollIndicator horizontal = {true} >
 {stopCodes === false && <BarChart brdWdth={0}/>} 
</ScrollView>
</View>
<View style={{flexDirection:'column', alignSelf: 'center', //The stock alert row
}}>
<ScrollView style = {{
  width: 300, 
  alignSelf: 'center', 
  borderWidth: 2, 
  borderRadius: 10, 
  borderColor:'#DCE3E8',
  marginVertical:10,}} showsHorizontalScrollIndicator horizontal = {true} >
<View style={{...stylesBox.smallBox, width:500, height:320, alignSelf: 'center', borderWidth: 0, margin: 0, marginVertical: 0}}>
  <Text style={{...stylesBox.mediumText, fontSize:20, alignSelf:'flex-start', color:'black', marginLeft:20, marginTop:20}}>
    Stock Alert
  </Text>
  
  <View>
    <View style={{flexDirection:'column'}}>
      <Text style={{...stylesBox.mediumText, textAlign:'left', marginTop:20, marginBottom:10, marginLeft:20, fontSize:18, fontWeight:'500', color:'black'}}>
        Lowest 3 stock
      </Text>
      <View style={{flexDirection:'row'}}>
        <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color: darkColour}}>
         {lowOne}
        </Text>
        <View style={{flex:1}}>
          <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
            <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#CC2608'}}>
               {lowOneQ}
            </Text>
            
          </View>
        </View>
      </View>

      <View style={{flexDirection:'row'}}>
        <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color:darkColour}}>
        {lowTwo}
        </Text>
        <View style={{flex:1}}>
          <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
            <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#CC2608'}}>
            {lowTwoQ}
            </Text>
            
          </View>
        </View>
      </View>
      <View style={{flexDirection:'row'}}>
        <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color:darkColour}}>
        {lowThree}
        </Text>
        <View style={{flex:1}}>
          <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
            <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#CC2608'}}>
            {lowThreeQ}
            </Text>
            
          </View>
        </View>
      </View>
    </View>

    <View style={{flexDirection:'column'}}>
      <Text style={{...stylesBox.mediumText, marginTop: 20, marginBottom:10, textAlign:'left', marginLeft:20, fontSize:18, fontWeight:'500', color:'black'}}>
        Highest 3 stock
      </Text>
      <View style={{flexDirection:'row'}}>
        <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color:darkColour}}>
        {highOne}
        </Text>
        <View style={{flex:1}}>
          <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
            <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#099B2F'}}>
                {highOneQ}
            </Text>
            
          </View>
        </View>
      </View>

      <View style={{flexDirection:'row'}}>
        <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color: darkColour}}>
       {highTwo}
        </Text>
        <View style={{flex:1}}>
          <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
            <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#099B2F'}}>
                {highTwoQ}
            </Text>
            
          </View>
        </View>
      </View>
      <View style={{flexDirection:'row'}}>
        <Text  style={{...stylesBox.mediumText, textAlign:'left', marginLeft:20, fontSize:15, color:darkColour}}>
        {highThree}
        </Text>
        <View style={{flex:1}}>
          <View style={{flexDirection:'row', alignSelf:'flex-end'}}>
            <Text style={{...stylesBox.mediumText, textAlign:'left', marginRight:20, fontSize:15, color:'#099B2F'}}>
                {highThreeQ}
            </Text>
            
          </View>
        </View>
      </View>
    </View>

  </View>
</View>
</ScrollView>
<View>
  <ScrollView style={{...stylesBox.smallBox, height:442, margin: 0, width:300, marginLeft: 0, marginTop: 0, alignSelf: 'center'}} horizontal = {true}>
     {stopCodes === false &&  <DataGridView/>}
  </ScrollView>
</View>
<View style={{...stylesBox.smallBox, width:410, height:320, margin: 0, alignSelf: 'center'}}>
  <View style={{height:160, borderWidth:0, borderBottomWidth:1, alignItems:'center'}}>
     <TouchableOpacity style={{width:370, height: 40, marginTop:10, backgroundColor: darkColour, borderRadius:10, flexDirection:'row',
      borderBottomLeftRadius: zeroModal? 0 : 10, borderBottomRightRadius: zeroModal? 0 : 10 }} onPress={fetchZeroBoards}>
        <Text style={{...stylesBox.mediumText, color:'white', flex:7, marginRight:0, paddingTop:5, fontSize:17}}>
          Out of stock boards
        </Text>
        <View style={{flex:1, alignItems:'flex-end'}}>
          <IconButton icon= {zeroModal? "chevron-down" : "chevron-up"} 
          iconColor={'white'} size={25} style={{width:34, height:34, margin:3, padding:2}} containerColor={'transparent'} focusable={false} />
        </View>
      </TouchableOpacity>
  </View>

  <View style={{height:160, borderWidth:0, alignItems:'center'}}>
    <TouchableOpacity style={{width:370, height: 40, marginTop:10, backgroundColor: darkColour, borderRadius:10, flexDirection:'row', 
      borderBottomLeftRadius: expensesModal? 0 : 10, borderBottomRightRadius: expensesModal? 0 : 10 }} onPress={handleExpenses}>
        <View style={{flex:2, alignItems:'flex-end'}}>
          <IconButton icon="plus-box-outline" iconColor={'white'} size={25} style={{width:34, height:34, margin:3, padding:2}} 
          containerColor={'transparent'} focusable={true} onPress={()=> setAddExpensesModal(true)}/>
        </View>
        <Text style={{...stylesBox.mediumText, color:'white', flex:7, marginRight:0, paddingTop:5, fontSize:17}}>
          Expenses tab
        </Text>
        {oneOnly?.trim() !== '' &&
        <View style={{flex:2, alignItems:'flex-start'}}>
          <IconButton icon="trash-can" iconColor={'white'} size={25} style={{width:34, height:34, margin:3, padding:2}} 
          containerColor={'transparent'} focusable={true} onPress={()=>deleteSelected(oneOnly)} />
        </View>
        }
        <View style={{flex:1, alignItems:'flex-end'}}>
          <IconButton icon= {expensesModal? "chevron-down" : "chevron-up"}
          iconColor={'white'} size={25} style={{width:34, height:34, margin:3, padding:2}} containerColor={'transparent'} focusable={false} />
        </View>
    </TouchableOpacity>
  </View>

</View>
</View>
<View style={{flexDirection:'column', marginBottom: 10, alignSelf: 'center'}}>
<View style={{marginTop:10}}>
  <AddStock onClicked={handleAddStock} showModal={isDisabled}/>
</View>

<View style={{flex:1, alignItems:'flex-start'}}>
  <View style={{ marginTop:10}}>
    <MyButton 
    btnText='View stock' 
    btnBorClr={isColorWhite}
    btnBorWdt={0} 
    btnColor={darkColour} 
    btnHeight={40} 
    btnTxtClr={isColorWhite}
    btnFontSize={17}
    btnWidth={200}
    btnBorRadius={10}
    btnPadding={9}
    hndClicked={handleViewStock}
    />
  </View>
</View>

<View style={{flex:1, alignItems:'flex-start'}}>
  <View style={{ marginTop:10}}>
    <MyButton 
    btnText='Purchase history' 
    btnBorClr={isColorWhite}
    btnBorWdt={0} 
    btnColor={darkColour} 
    btnHeight={40} 
    btnTxtClr={isColorWhite}
    btnFontSize={17}
    btnWidth={200}
    btnBorRadius={10}
    btnPadding={9}
    hndClicked={handlePurchaseHistory}
    />
  </View>
</View>

<View style={{flex:1, alignItems:'flex-start'}}>
  <View style={{ marginTop:10}}>
    <MyButton 
    btnText='Saved For Later' 
    btnBorClr={isColorWhite}
    btnBorWdt={0} 
    btnColor={darkColour} 
    btnHeight={40} 
    btnTxtClr={isColorWhite}
    btnFontSize={17}
    btnWidth={200}
    btnBorRadius={10}
    btnPadding={9}
    hndClicked={handleSavedForLater}
    />
  </View>
</View>
<View style={{flex:1, alignItems:'flex-start'}}>
  <View style={{ marginTop:10}}>
    <MyButton 
    btnText='Sales per customer' 
    btnBorClr={isColorWhite}
    btnBorWdt={0} 
    btnColor={darkColour} 
    btnHeight={40} 
    btnTxtClr={isColorWhite}
    btnFontSize={17}
    btnWidth={200}
    btnBorRadius={10}
    btnPadding={9}
    hndClicked={handleSalesPerCustomer}
    />
  </View>
</View>

<View style={{flex:1, alignItems:'flex-start'}}>
  <View style={{ marginTop:10}}>
    <MyButton 
    btnText='Total and expenses' 
    btnBorClr={isColorWhite}
    btnBorWdt={0} 
    btnColor={darkColour} 
    btnHeight={40} 
    btnTxtClr={isColorWhite}
    btnFontSize={17}
    btnWidth={200}
    btnBorRadius={10}
    btnPadding={9}
    hndClicked={handleTotalAndExpenses}
    />
  </View>
</View>

<View style={{flex:1, alignItems:'flex-start'}}>
  <View style={{ marginTop:10}}>
    <MyButton 
    btnText='Report' 
    btnBorClr={isColorWhite}
    btnBorWdt={0} 
    btnColor={darkColour} 
    btnHeight={40} 
    btnTxtClr={isColorWhite}
    btnFontSize={17}
    btnWidth={200}
    btnBorRadius={10}
    btnPadding={9}
    hndClicked={handleReport}
    />
  </View>
</View>
</View>

<View style = {{ width: '100%'}}>
<PaperProvider>
<Portal>
<Modal visible = {zeroModal} contentContainerStyle={{width:370, maxHeight: 100, borderWidth: 0, borderColor: 'transparent', marginTop: zeroBoards.length + 10 < 1 ? -1211 : zeroBoards.length > 2 ? -1146 : -1244 + (zeroBoards.length * 33 ), alignSelf: 'center', position:'relative' }} onDismiss={()=>setZeroModal(false)}>
  <ScrollView style={{borderColor:'black', borderWidth:2, borderTopWidth:0, borderBottomRightRadius:10, borderBottomLeftRadius:10}}>
    {zeroBoards.length > 0 ? zeroBoards.map((item, index) => (
      <ChildProvider
        key={item.itemName}
        texts={[item.itemName, item.quantity.toString()]}
        index={index}
        isExpenses = {false}
        isChecked = {false}
        pressed={()=>{}}
        id={item.itemName}
      />
    )) 
    : 
    <View style={{...stylesBox.childStyle, justifyContent:'center'}}>
      <Text style= {stylesBox.noZeroStock}>
        There is no out of stock boards
      </Text>
    </View>
    }
  </ScrollView>
</Modal>
</Portal>
</PaperProvider>
</View>


<PaperProvider>
<Portal>
<Modal visible = {expensesModal} contentContainerStyle={{width:370, maxHeight: 100, marginTop: expensesArray.length + 10 < 1 ? -891 : expensesArray.length > 2 ? -826 : -924 + (expensesArray.length * 33 ), alignSelf: 'center', position:'relative' }} onDismiss={()=>setExpensesModal(false)}>
  <ScrollView style={{borderColor:'black', borderWidth:2, borderTopWidth:0, borderBottomRightRadius:10, borderBottomLeftRadius:10}}>
    {expensesArray.length > 0 ? expensesArray.map((item, index) => (
      <ChildProvider
        key={item.id}
        texts={[item.description, Number(item.amount).toLocaleString('en-NG', { style: 'currency', currency: 'NGN' })]}
        index={index}
        isExpenses = {true}
        isChecked={oneOnly === item.id?.toString() ? true : false}
        pressed={() =>{handleExpensesPressed(item.id)}}
        id={item.id?.toString()}
      />
    )) 
    : 
    <View style={{...stylesBox.childStyle, justifyContent:'center'}}>
      <Text style= {stylesBox.noZeroStock}>
        No expenses yet made today
      </Text>
    </View>
    }
  </ScrollView>
</Modal>
</Portal>
</PaperProvider>

<PaperProvider>
<Portal>
<Modal visible = {addExpensesModal} contentContainerStyle={{width:370, height: 145, backgroundColor:'white', borderWidth:2, borderColor:darkColour, borderRadius:10, marginTop: -892, alignSelf: 'center'}} onDismiss={()=>setZeroModal(false)}>
  <View style={{paddingVertical:5}}>
    <View style={{width:370, paddingHorizontal:3, flexDirection:'row'}}>
      <TextInputTemp refObject={qtyRef} lTxt="Amount(₦)" plhrTxt="Enter amount" cnWidth={220} 
        txtWidth={118} lbWidth={100} makeDigits ={true} onChangeText={(amt)=>setExpAmount(amt)} 
        enterKeyIsSunmit = {true} onSubmit={handleAddToExpenses}
      />
      <View style={{flex: 1, height:40, justifyContent:'flex-end', alignItems:'center' , marginTop:10, paddingHorizontal:4, flexDirection:'row'}}>
        <View>
           <MyButton btnText='Add' btnWidth={60} hndClicked={handleAddToExpenses} />
        </View>
       
        <IconButton icon="close-box" iconColor={darkColour} size={30} style={{width:45, height:45, margin:0, padding:2}} 
          containerColor={'transparent'} focusable={true} onPress={()=> setAddExpensesModal(false)}
        />
      </View>
    </View>

    <View style={{alignSelf:'center'}}>
      <ReactText
        placeholder= 'Expenses description'
        multiline
        numberOfLines={4}
        spellCheck ={false}
        style={stylesBox.notesText}
        onChangeText={(text)=> setDescriptionText(text)}
      />
    </View>

  </View>
</Modal>
</Portal>
</PaperProvider>

</ScrollView>
  }
  </PaperProvider>
  
  )
};

const stylesBox = StyleSheet.create ({
  smallBox: {
    width: 190, 
    height:120, 
    backgroundColor:'white', 
    borderRadius:10, 
    borderWidth:2, 
    borderColor:'#DCE3E8',
    marginVertical:10,
    margin: 10,
    alignContent:'center'
  },
  smallText: {
    color:'#616161', 
    //fontFamily:'century gothic', 
    fontSize:12, 
    fontWeight:'300', 
    textAlign:'center',
  },
  bigText: {
    color:'#2A6AA7', 
    //fontFamily:'century gothic', 
    fontSize:30, 
    fontWeight:'normal', 
    textAlign:'center',
  },
  mediumText: {
    color:darkColour, 
    //fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal', 
    textAlign:'center',
    marginTop:5,
    },
    overlay: {
      ...StyleSheet.absoluteFillObject,
     
    },
  childStyle: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'white',
    height:35,
    borderColor:'black',
    borderTopWidth:2,
    borderBottomWidth:0,
    marginTop:-2
  },
  childSubStyle: {
    width:340,
    borderWidth:2, 
    borderColor:'black', 
    height:'100%', 
    alignItems:'center', 
    marginLeft:-2, 
    borderTopWidth:0, 
    borderBottomWidth:0
  },
  childTextStyle: {
    color: '#BF2321',
    //fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal',
    marginTop:6,
  },
  noZeroStock: {
    marginTop:3, 
    fontStyle: 'italic',
    color: darkColour,
    //fontFamily:'century gothic', 
    fontSize:15, 
    fontWeight:'normal',
  },
  notesText: {
    borderWidth: 1,
    borderRadius:10,
    borderColor: '#DCE3E8',
    width:340,
    height:70,
    padding:10,
    paddingBottom:5,
    color:'black', 
    //fontFamily:'century gothic', 
    fontSize:16, 
    fontWeight:'300',
    marginBottom:10,
    marginHorizontal:0,
    alignSelf:'center'
  },
})

export default Dashboard;
